import React, { Suspense, useContext, useEffect, useMemo } from 'react';
import utils from '../utils';
import InputBox from '../InputBox';
import ModifySearchContext from '../ModifySearchContext';
import { getMMT_HLD_OBJ } from '../../../utils/appUtils';
import DestSearch from './DestSearch';
import { getUrlParamsMapV2 } from '../../../utils/browserUtils';
import { getRecentSearch } from '../../../utils/searchUtils';

const SelectDestination = ({
  label = 'Going To',
  value = '',
  handleChange,
  onFocus,
  onNext,
  next = false,
  openBox = null,
  searchButtonClicked = false,
  setsearchButtonClicked,
  landOnly = null,
  name = '',
  departureCity = '',
  showLocationIcon = false,
  alwaysShowDestV2 = false,
  icon,
}) => {
  const { setActiveControl } = useContext(ModifySearchContext);

  const showDestV2 = useMemo(() => {
    if (alwaysShowDestV2) {
      return true;
    }
    const params = getUrlParamsMapV2();
    return params.rooms && getMMT_HLD_OBJ().destinationSearchV2;
  }, []);

  useEffect(() => {
    if (openBox !== null) {
      setActiveControl(openBox);
      setsearchButtonClicked(false);
    }
  }, [openBox, searchButtonClicked]);

  const handleCityChange = cityData => {
    if (next && onNext) {
      onNext();
    }
    setActiveControl(next || null);
    handleChange(cityData);
  };
  const recentSearch = useMemo(() => (ssr.isOnClient ? getRecentSearch() : null), []);

  return (
    <InputBox
      name={name}
      value={utils.getDisplayValue('citypicker', value)}
      label={label}
      disableInput={landOnly}
      tooltipText={''}
      onFocus={onFocus}
      showLocationIcon={showLocationIcon}
      icon={icon}
    >
      <Suspense fallback={<></>}>
        <DestSearch
          label="To"
          onChange={handleCityChange}
          showDestV2
          departureCity={departureCity}
          recentSearch={recentSearch}
        />
      </Suspense>
    </InputBox>
  );
};

export default SelectDestination;
